export default "__VITE_ASSET__DH8yq33U__"